import script from "./TempL.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempL.vue?vue&type=script&lang=ts&setup=true"

import "./TempL.vue?vue&type=style&index=0&id=ab44f59a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab44f59a"]])

export default __exports__